import { get, post, del } from "../helpers/api_helper"

// Attendance codes
export const getAttendanceCodes = () => get("attendance-codes")
export const saveAttendanceCode = (id, data) => (id ? post(`attendance-codes/${id}`, data) : post("attendance-codes", data))
export const deleteAttendanceCode = id => del(`attendance-codes/${id}`)

// Trades
export const getTrades = (companyId) => get(`trades${companyId ? `?company_id=${companyId}` : ""}`)
export const saveTrade = (id, data) => (id ? post(`trades/${id}`, data) : post("trades", data))
export const deleteTrade = id => del(`trades/${id}`)
export const toggleTrade = id => post(`trades/${id}/active`, {})
export const setTradeRate = (id, data) => post(`trades/${id}/rate`, data)
export const getTradeHistory = (id, scope, scopeId) =>
  get(`trades/${id}/history?scope=${scope}${scopeId ? `&scope_id=${scopeId}` : ""}`)

// Attendance code overrides (per-company)
export const getCompanyAttendanceCodes = companyId => get(`attendance-codes/company/${companyId}`)
export const setAttendanceOverride = (id, data) => post(`attendance-codes/${id}/override`, data)
export const getAttendanceOverrideHistory = (id, scope, scopeId) =>
  get(`attendance-codes/${id}/override-history?scope=${scope}${scopeId ? `&scope_id=${scopeId}` : ""}`)

// Document types
export const getDocumentTypes = () => get("document-types")
export const saveDocumentType = (id, data) => (id ? post(`document-types/${id}`, data) : post("document-types", data))
export const deleteDocumentType = id => del(`document-types/${id}`)
